import { useLoadingAction } from 'src/hooks/use-actions';
import { apiCreateST, apiUpdateST, apiDeleteST } from './data-form';
import { convertResponseItem } from './helper';

const useForms = () => {

  const createStudentTracking = (payload, onSuccess, onError) => {
    return useLoadingAction(apiCreateST, payload, (result) => {
        const jsonResult = convertResponseItem(result);
        // console.log('======', jsonResult);
        onSuccess(jsonResult);
    }, onError);
  }
  const updateStudentTracking = (payload, onSuccess, onError) => {
    return useLoadingAction(apiUpdateST, payload, (result) => {
      const jsonResult = convertResponseItem(result);
      onSuccess(jsonResult);
    }, onError);
  }
  const deleteStudentTracking = (payload, onSuccess, onError) => {
    return useLoadingAction(apiDeleteST, payload, (result) => {
      console.log('====== DELETED ', result);
      // const jsonResult = convertResponseItem(result);
      onSuccess(result);
    }, onError);
  }

  return {
    createStudentTracking,
    updateStudentTracking,
    deleteStudentTracking,
  };
};

export default useForms;
